// @flow
import { all, call, put, fork, takeEvery } from 'redux-saga/effects';

import { INIT_MENU, CHANGE_ACTIVE_MENU_FROM_LOCATION, FETCH_MAINTENANCE_REQUEST_BADGE, FETCH_CHAT_USER_BADGE, FETCH_CHAT_TECHNICIAN_BADGE } from './constants';
import { authProtectedRoutes as routes, authAdminCompanyProtectedRoutes as adminCompanyRoutes, authAdminSuperProtectedRoutes as adminSuperRoutes } from '../../routes';
import assignIds from './utils';
import { initMenuSuccess, changeActiveMenuFromLocationSuccess, fetchMaintenanceRequestBadgeSuccess, fetchChatUserBadgeSuccess, fetchChatTechnicianBadgeSuccess } from './actions';
import apiMaintenanceRequest from '../../api/apiMaintenanceRequest';
import apiChat from '../../api/apiChat';

/**
 * Activate menu items from location
 * @param {*} menuItems
 */
const getActivatedMenuItemIds = menuItems => {
    var matchingItems = [];
    for (var menuItem of menuItems) {
        if (window.location.pathname.indexOf(menuItem.path) === 0) {
            matchingItems.push(menuItem.id);
        }

        if (typeof menuItem.children !== 'undefined') {
            matchingItems = [...matchingItems, ...getActivatedMenuItemIds(menuItem.children)];
        }
    }
    return matchingItems;
};

/**
 * Initilizes the menu
 */
function* initMenuAndItems() {
    try {
        const menuItems = assignIds(routes());
        yield put(initMenuSuccess(menuItems));
    } catch (error) {}
}

/**
 * change the active menu item based on location
 */
function* changeActiveMenuFromLocation() {
    try {
        const menuItems = assignIds(routes());
        const activatedMenuItemIds = yield call(getActivatedMenuItemIds, menuItems);
        yield put(changeActiveMenuFromLocationSuccess(activatedMenuItemIds));
    } catch (error) {}
}

/**
 BADGE UPDATE
 **/
 function* fetchMaintenanceRequestBadgeSaga()  {
    try {
        const res = yield call(fetchMaintenanceRequestBadgeAsync);
       yield put(fetchMaintenanceRequestBadgeSuccess(res ? res.response ? res.response.count ?? 0 : 0 : 0)); //
    } catch (e) {
       yield put(fetchMaintenanceRequestBadgeSuccess(0));
    }
 }

 async function fetchMaintenanceRequestBadgeAsync()  {
    return await apiMaintenanceRequest.countMaintenance({status: 'request'});
 }

 function* fetchChatUserBadgeSaga()  {
    try {
        const badgeCount = yield call(fetchChatUserBadgeAsync);
       yield put(fetchChatUserBadgeSuccess(badgeCount ?? 0)); //
    } catch (e) {
       yield put(fetchChatUserBadgeSuccess(0));
    }
 }

 async function fetchChatUserBadgeAsync()  {
    return await apiChat.getBadgeAllGroupChats({groupType: "user"});
 }

 function* fetchChatTechnicianBadgeSaga()  {
    try {
        const badgeCount = yield call(fetchChatTechnicianBadgeAsync);
       yield put(fetchChatTechnicianBadgeSuccess(badgeCount ?? 0)); //
    } catch (e) {
       yield put(fetchChatTechnicianBadgeSuccess(0));
    }
 }

 async function fetchChatTechnicianBadgeAsync()  {
    return await apiChat.getBadgeAllGroupChats({groupType: "technician"});
 }



/**
 * Watchers
 */
export function* watchMenuInit() {
    yield takeEvery(INIT_MENU, initMenuAndItems);
}

export function* watchMenuChange() {
    yield takeEvery(CHANGE_ACTIVE_MENU_FROM_LOCATION, changeActiveMenuFromLocation);
}

export function* watchMaintenanceBadgeChange() {
    yield takeEvery(FETCH_MAINTENANCE_REQUEST_BADGE, fetchMaintenanceRequestBadgeSaga);
}

export function* watchChatUserBadgeChange() {
    yield takeEvery(FETCH_CHAT_USER_BADGE, fetchChatUserBadgeSaga);
}

export function* watchChatTechnicianBadgeChange() {
    yield takeEvery(FETCH_CHAT_TECHNICIAN_BADGE, fetchChatTechnicianBadgeSaga);
}

function* appMenuSaga() {
    yield all([fork(watchMenuInit), fork(watchMenuChange), fork(watchMaintenanceBadgeChange), fork(watchChatUserBadgeChange), fork(watchChatTechnicianBadgeChange)]); 
}

export default appMenuSaga;
